// @owners { team: patient-health }
import { Button } from '@alto/design-system';
import React from 'react';
import { useAnalytics } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { type ShipmentStatus } from '~shared/types/shipments';

type CancelButtonProps = {
  readonly openCancelDeliveryModal: () => void;
  readonly shipmentID?: number;
  readonly shipmentIsEditable?: boolean;
  readonly status?: ShipmentStatus;
};

export const CancelButton = ({
  openCancelDeliveryModal,
  shipmentID,
  shipmentIsEditable,
  status,
}: CancelButtonProps) => {
  const { trackEvent } = useAnalytics();

  if (!shipmentIsEditable && (status === 'shipped' || status === 'delivered')) return null;

  const onPress = () => {
    openCancelDeliveryModal();
    trackEvent({ event: EVENTS.DELIVERY_DETAILS_CANCEL_BUTTON_CLICKED, additionalFields: { shipmentId: shipmentID } });
  };

  return (
    <Button
      accessibilityLabel="Cancel Delivery Button"
      onPress={onPress}
      small
      testID="cancel-delivery-button"
      type="secondary"
      variant="danger"
      width="inline"
    >
      Cancel
    </Button>
  );
};
